import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Provider approves new client signup
 *
 */
export default async function approveNewPatient(clientSignupToken: string) {
  const res = await fetchOrchidAPI(
    `/api/users/v1/patient_signup_session/approve/${clientSignupToken}`,
    {
      method: "POST",
    },
  );
  if (!res.ok) {
    throw new Error(
      `failed to approve client signup: ${getErrorDetail(await res.text())}`,
    );
  }

  return;
}
